import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';
import { TagDetailsFormViewData } from '../types/TagDetailsFormViewData';

export class TagDetailsFormBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<TagDetailsFormViewData> {
    throw new Error('Not implemented');
  }
}
